import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';

export interface IFormError {
  control: string;
  errors: ValidationErrors;
}

@Injectable({
  providedIn: 'root',
})
export class FormErrorSupportService {
  findErrors(form: FormGroup, rootControlName: string = 'form'): IFormError[] {
    const errors: IFormError[] = form.errors
      ? [
          {
            control: rootControlName,
            errors: form.errors,
          },
        ]
      : [];
    Object.keys(form.controls).forEach(control => {
      if (form.controls[control].errors) {
        errors.push({
          control,
          errors: form.controls[control].errors,
        });
      }
      if ((form.controls[control] as FormGroup)?.controls) {
        errors.push(
          ...this.findErrors(form.controls[control] as FormGroup, control)
        );
      }
    });
    return errors;
  }
}
